import { Dialog, DialogBody, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

/**
 * Props for the UserMassImportInfo component.
 * @property {boolean} open - Whether the dialog is open.
 * @property {(value: boolean) => void} onOpenChange - Callback to change dialog open state.
 */
interface UserMassImportInfoProps {
  open: boolean;
  onOpenChange: (value: boolean) => void;
}

export default function UserMassImportInfo(userMassImportInfoProps: UserMassImportInfoProps) {
  const { open, onOpenChange } = userMassImportInfoProps;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={'md:max-w-xl'}>
        <DialogBody>
          <DialogHeader className={'bg-card flex flex-col border-b'}>
            <DialogTitle>Nazwy kolumn</DialogTitle>
            <DialogDescription>
              Dane użytkownika są importowane z pliku CSV. Plik powinien zawierać kolumny o podanych nazwach. Pola oznaczone symbolem (<span className={'text-text-destructive font-semibold'}>*</span>)
              są wymagane.
            </DialogDescription>
          </DialogHeader>
          <ul className={'list-disc space-y-1 py-6 pr-4 pl-8'}>
            <li className={'text-text-secondary text-sm'}>
              <span>Imię / imie / name</span>
              <span className={'text-text-destructive font-semibold'}> *</span>
            </li>
            <li className={'text-text-secondary text-sm'}>
              <span>nazwisko / surname</span> <span className={'text-text-destructive font-semibold'}> *</span>
            </li>
            <li className={'text-text-secondary text-sm'}>
              <span>email / e-mail / adres e-mail</span> <span className={'text-text-destructive font-semibold'}> *</span>
            </li>
            <li className={'text-text-secondary text-sm'}>
              <span>poświadczenia / rola / lvl / permissions</span> <span className={'text-text-destructive font-semibold'}> *</span>
            </li>
            <li className={'text-text-secondary text-sm'}>telefon / nr tel / numer telefonu / phone number / phone</li>

            <li className={'text-text-secondary text-sm'}>data urodzenia / birthdate / birthday</li>
          </ul>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
